import { IRiskAppStage } from '../types';
import { EntityService } from './EntityService';

export class RiskAppStageService extends EntityService<IRiskAppStage> {
    constructor() {
        super(`/RiskAppStages`);
    }

    public readAllForLookup(includeClosed?: boolean): Promise<IRiskAppStage[]> {
        return this.readAll(
            `?$select=ID,Title,ForIssue,ForIncident`
            + `&$orderby=Title`
        );
    }
}